module.exports = __webpack_public_path__ + "static/media/vegan-birthday-cake.b8489d67.png";